'use client';
import './globals.css';

export { GlobalErrorPageSport as default } from '@svs/nova-foundation/nextjs/pages';
